module.exports = __webpack_public_path__ + "img/Slide19.7780793a.png";